import React, { useContext } from 'react'
import styled from 'styled-components'
import { useMutation } from '@apollo/client'
import { CurrentLegalFormalityContext } from 'contexts/LegalFormalityContext'
import { LEGAL_FORMALITY_LEGAL_DEPOSIT_CREATE_MUTATION } from 'graphql/LegalFormalities'

const EmptyDeposits = () => {
  const { legalFormality, legalFormalityRefetch } = useContext(
    CurrentLegalFormalityContext
  )
  const [createDeposit, { loading }] = useMutation(
    LEGAL_FORMALITY_LEGAL_DEPOSIT_CREATE_MUTATION,
    {
      variables: { id: parseInt(legalFormality.id) },
      onCompleted: () => legalFormalityRefetch(),
    }
  )

  return (
    <EmptyWrapper>
      <EmptyText>Aucun dépôt légal</EmptyText>
      <AddButton disabled={loading} onClick={() => createDeposit()}>
        {loading ? 'Création…' : '+ Ajouter un dépôt'}
      </AddButton>
    </EmptyWrapper>
  )
}

export default EmptyDeposits

// ─── Styles ───────────────────────────────────────────────────────────────────

const EmptyWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 16px;
  padding: 40px 20px;
  color: #92979c;
`

const EmptyText = styled.p`
  font-size: 16px;
  margin: 0;
`

const AddButton = styled.button`
  background: #55d381;
  color: #fff;
  border: none;
  border-radius: 8px;
  padding: 10px 20px;
  font-size: 15px;
  font-weight: 600;
  cursor: pointer;
  transition: background 0.2s;

  &:hover:not(:disabled) {
    background: #3dbf6a;
  }

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }
`
